import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  packages: [],
  companies: [],
  isCompaniesLoading: false,
  isPackagesLoading: false,
  commodities: [],
  totalPackages: 0,
};

const packageListSlice = createSlice({
  name: "packageList",
  initialState,
  reducers: {
    fetchPackages(state, action) {
      state.isPackagesLoading = true;
      state.packages = [];
    },
    fetchPackagesSuccess(state, action) {
      state.packages = action.payload.data.document;
      state.totalPackages = action.payload.data?.paginationMetadata?.total;
      state.isPackagesLoading = false;
    },
    fetchPackagesFailure(state, action) {
      state.isPackagesLoading = false;
    },
    fetchCompanies(state, action) {
      state.isCompaniesLoading = true;
    },
    fetchCompaniesSuccess(state, action) {
      state.companies = action.payload.data.document;
      state.isCompaniesLoading = false;
    },
    fetchCompaniesFailure(state, action) {
      state.isCompaniesLoading = false;
    },

    fetchCommodities(state) {
      state.commodities = [];
    },
    fetchCommoditiesSuccess(state, action) {
      state.commodities = action.payload.data.document;
    },
    fetchCommoditiesFailure(state, action) {},
  },
});

export const { actions, reducer, name: sliceKey } = packageListSlice;
